/* DURREVO animation engine — IntersectionObserver-driven scroll animations, controlled per-section via data attributes */

(function () {
  'use strict';

  var DEFAULT_DURATION = 700;
  var DEFAULT_EASING = 'cubic-bezier(0.25, 0.46, 0.45, 0.94)';
  var STAGGER_STEP = 120;
  var THRESHOLD = 0.15;

  var SPEED_MAP = {
    slow: 1000,
    normal: 700,
    fast: 400,
  };

  function DurrevodAnimationEngine() {
    this.observer = null;
    this.elements = [];
  }

  DurrevodAnimationEngine.prototype.init = function () {
    if (document.documentElement.hasAttribute('data-animations-disabled')) {
      return;
    }

    this.applyStagger();

    this.elements = Array.prototype.slice.call(document.querySelectorAll('[data-animate]'));

    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: THRESHOLD,
    });

    this.elements.forEach(
      function (element) {
        this.observer.observe(element);
      }.bind(this)
    );

    console.log('[DURREVO] Animation engine initialized — ' + this.elements.length + ' elements found');
  };

  DurrevodAnimationEngine.prototype.applyStagger = function () {
    var staggerParents = document.querySelectorAll('[data-animate-stagger]');

    staggerParents.forEach(function (parent) {
      var children = Array.prototype.slice.call(parent.children);

      children.forEach(function (child, index) {
        if (!child.hasAttribute('data-animate')) {
          child.setAttribute('data-animate', 'fade-up');
        }

        var existingDelay = parseInt(child.getAttribute('data-animate-delay'), 10);
        if (isNaN(existingDelay)) {
          existingDelay = 0;
        }

        child.setAttribute('data-animate-delay', String(existingDelay + index * STAGGER_STEP));
      });
    });
  };

  DurrevodAnimationEngine.prototype.handleIntersect = function (entries, observer) {
    entries.forEach(
      function (entry) {
        if (!entry.isIntersecting) {
          return;
        }

        this.reveal(entry.target);
        observer.unobserve(entry.target);
      }.bind(this)
    );
  };

  DurrevodAnimationEngine.prototype.reveal = function (element) {
    var duration = this.getDuration(element);
    var easing = element.getAttribute('data-animate-easing') || DEFAULT_EASING;
    var delay = parseInt(element.getAttribute('data-animate-delay'), 10);
    if (isNaN(delay)) {
      delay = 0;
    }

    element.style.transitionDuration = duration + 'ms, ' + duration + 'ms';
    element.style.transitionTimingFunction = easing + ', ' + easing;
    element.style.transitionDelay = delay + 'ms, ' + delay + 'ms';

    requestAnimationFrame(function () {
      element.classList.add('is-visible');
    });

    window.setTimeout(function () {
      element.style.transitionDelay = '';
    }, duration + delay);
  };

  DurrevodAnimationEngine.prototype.getDuration = function (element) {
    var explicitDuration = parseInt(element.getAttribute('data-animate-duration'), 10);
    if (!isNaN(explicitDuration)) {
      return explicitDuration;
    }

    var speed = element.getAttribute('data-animate-speed');
    if (speed && SPEED_MAP.hasOwnProperty(speed)) {
      return SPEED_MAP[speed];
    }

    return DEFAULT_DURATION;
  };

  window.DurrevodAnimationEngine = DurrevodAnimationEngine;

  document.addEventListener('DOMContentLoaded', function () {
    var engine = new DurrevodAnimationEngine();
    engine.init();
    window.durrevodAnimationEngine = engine;
  });
})();
